services.service('LocationService', [
    'constants', 'API',
    function (Const, API) {

        this.enter = function (location) {
            if (!location) return;
            return API.location({location: location});
        };

        return this;
    }
]);
